import { useRef, useEffect } from 'react'

import { useHospitalDetailContext } from '../hospital-detail-context'

import { HospitalEventSection } from '@/features/hospital/components/hospital-event-section'

export const HospitalDetailEvents = () => {
  const { user, hospital, events, registerSectionRef } = useHospitalDetailContext()
  const sectionRef = useRef<HTMLDivElement>(null)

  // Register section ref for scroll navigation
  useEffect(() => {
    registerSectionRef('event', sectionRef.current)
    return () => registerSectionRef('event', null)
  }, [registerSectionRef])

  // 이벤트가 없으면 렌더링하지 않음
  if (!events || events.length === 0) {
    return null
  }

  return (
    <div ref={sectionRef}>
      <HospitalEventSection className="visible" events={events} hospital={hospital} user={user} />
    </div>
  )
}
